"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = __importDefault(require("../scss/colors"));
const InlineButton = styled_components_1.default.button `
    text-align: center;
    cursor: pointer;
    border-radius: 5px;
    margin: 0 8px 0 0;
    font-family: inherit;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    line-height: 1em;
    padding: ${(props) => (props.secondary ? "8px" : "10px")};
    background: ${(props) => props.secondary ? colors_1.default.white : colors_1.default.blue2};
    color: ${(props) => (props.secondary ? colors_1.default.blue2 : colors_1.default.white)};
    border: ${(props) => props.secondary ? `2px solid ` + colors_1.default.blue2 : null};
    transition: background 0.08s;
    box-shadow: 0 2px 3px 0 rgba(52, 52, 52, 0.2);
    vertical-align: middle;
    &:hover {
        background: ${(props) => props.secondary ? colors_1.default.grey2 : colors_1.default.blue3};
    }
    ${(props) => {
    if (props.isLocked)
        return "pointer-events:none; background: #bbb; padding: 10px;";
}}
`;
exports.default = InlineButton;
